// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



// WEBPACK FOOTER //
// ./node_modules/core-js/modules/es7.weak-set.from.js